import React from 'react';
import styled from 'styled-components';

import CompareCheckbox from '@/components/CompareCheckbox';
import { isCarComparing } from '@/modules/CarsStock/components/common.helpers';
import {
  getComparisonCars,
  setComparisonCar,
} from '@/store/reducers/cars-stock';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function Compare() {
  const dispatch = useTypedDispatch();
  const data = useTypedSelector(selectDetailedCarData);
  const comparisonCars = useTypedSelector(getComparisonCars);

  if (!data) {
    return null;
  }

  return (
    <Component>
      <CompareCheckbox
        checked={isCarComparing(comparisonCars, data.id)}
        onChange={() =>
          dispatch(setComparisonCar({ carType: 'new', id: data.id }))
        }
      />
    </Component>
  );
}

export default Compare;

const Component = styled.div`
  z-index: 2;
  position: absolute;
  top: 5px;
  left: 5px;
`;
